import { render, staticRenderFns } from "./GenericFilters.vue?vue&type=template&id=6bada9a4&scoped=true&"
import script from "./GenericFilters.vue?vue&type=script&lang=js&"
export * from "./GenericFilters.vue?vue&type=script&lang=js&"
import style0 from "./GenericFilters.vue?vue&type=style&index=0&id=6bada9a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bada9a4",
  null
  
)

export default component.exports